import { Rug } from '../parts/props'
import type { AssetContext, AssetDefinition } from '../types'

const WIDTH = 2
const DEPTH = 1.4

/** Per-variant plan: the round rug is a square with a half-width corner radius. */
const PLANS = {
  large: { width: WIDTH, depth: DEPTH, radius: 0.1 },
  small: { width: 1.6, depth: 1.1, radius: 0.09 },
  round: { width: 1.6, depth: 1.6, radius: 0.8 },
} as const

type RugVariant = keyof typeof PLANS

/**
 * Floor rug. Deliberately the thinnest asset in the catalog: the pile tops out
 * at 16 mm so furniture placed over it never looks like it is floating, and the
 * inner accent field sits 2 mm proud of the border to keep the two coplanar
 * slabs from z-fighting.
 */
function RugItem({ accent, variant = 'large' }: AssetContext) {
  const plan = PLANS[variant as RugVariant] ?? PLANS.large

  return <Rug width={plan.width} depth={plan.depth} radius={plan.radius} accent={accent} />
}

export const definition: AssetDefinition = {
  id: 'rug',
  name: 'Alfombra',
  category: 'decor',
  footprint: [WIDTH, DEPTH],
  height: 0.02,
  accentable: true,
  variants: [
    { id: 'large', name: '2.0 x 1.4' },
    { id: 'small', name: '1.6 x 1.1' },
    { id: 'round', name: 'Redonda' },
  ],
  keywords: ['alfombra', 'tapete', 'rug', 'carpet', 'floor mat'],
  Component: RugItem,
}
